import { useTranslation } from "react-i18next";
import { generatePath, Navigate } from "react-router";
import { useProjectBySiteId } from "../../hooks/useProjectBySiteId";
import { useRouteSiteId } from "../../hooks/useRouteSiteId";
import { ROUTES } from "../../routes";
import { LoadOrError } from "../LoadOrError/LoadOrError";

function OldManagerStructureViewRoute() {
  const siteId = useRouteSiteId();
  const { data, isLoading, error } = useProjectBySiteId({ siteId });
  const redirectOnErrorPath = generatePath(ROUTES.dashboard);
  const { t } = useTranslation();

  const projectId = data?.id;

  const redirectPath =
    projectId && siteId
      ? generatePath(ROUTES.site.entry, {
          projectId: projectId,
          siteId: siteId.toString()
        })
      : null;

  const customErrors = {
    404: t("errors.SiteNotFound")
  };

  return (
    <LoadOrError
      customErrors={customErrors}
      error={error}
      errorRedirectTo={redirectOnErrorPath}
      loading={isLoading}
    >
      {redirectPath && <Navigate to={redirectPath} />}
    </LoadOrError>
  );
}

export { OldManagerStructureViewRoute };
